import ENV from '../constants/Env';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useStyles } from '../components/rides/rideFormStyles';
import { useRef } from 'react';
import MainLayout from '../components/layout/MainLayout';
import { useAuth } from '../contexts/auth-context';
import { useApolloClient, useLazyQuery } from '@apollo/client';
import {
  accountCustodianStorage,
  historyStorage,
  ridersStorage,
  upcomingRidesStorage,
} from '../storages/storage';
import { loader } from 'graphql.macro';
import { Custodian } from 'generated/graphql';
const CUSTODIANS_QUERY = loader('../data/queries/CustodiansQuery.graphql');

export default function ImpersonateUser() {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const auth = useAuth();
  const apolloClient = useApolloClient();
  const handledRef = useRef(false);

  const onBecome = (becomeCustodian: Custodian) => {
    auth.storeBecomeCustodian(apolloClient, { id: Number(becomeCustodian.id) });
    ridersStorage.clearStorage();
    upcomingRidesStorage.clearStorage();
    historyStorage.clearStorage();
    accountCustodianStorage.clearStorage();
  };

  const [fetchCustodians] = useLazyQuery(CUSTODIANS_QUERY, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userEmail = params.get('user');

    if (!userEmail || handledRef.current) return;

    (async () => {
      const { data } = await fetchCustodians({
        variables: { query: userEmail },
      });
      const custodian = data?.custodians?.find(
        ({ email }: { email: string }) => email === userEmail,
      );
      if (!custodian) return;

      handledRef.current = true;
      onBecome(custodian);
      params.delete('user');
      history.replace({ pathname: '/', search: params.toString() });
    })();
  }, [location.search, fetchCustodians, history]);

  return (
    <MainLayout usePadding="no">
      <iframe
        data-test-id="portal-iframe"
        title="Portal Impersonate"
        src={`${ENV.portalUrl}/impersonate?embeddedInDashboard=true`}
        className={classes.iframe}
      />
    </MainLayout>
  );
}
